<template>
    <div class="text-start bg-white p-2">
        <p class="small">{{ i18n('Password policy:') }}</p>
        <ul>
            <li class="small">{{ i18n('Must not contain proper names.') }}</li>
            <li class="small">{{ i18n('Must be 10 characters in length.') }}</li>
            <li class="small">{{ i18n('Must not repeat any of the last 24 passwords used.') }}</li>
            <li class="small">{{ i18n('Must be composed of characters from at least three of the following category:') }}
            </li>
            <ol>
                <li class="small">{{ i18n('Uppercase letters A to Z.') }}</li>
                <li class="small">{{ i18n('Lowercase letters a through z.') }}</li>
                <li class="small">{{ i18n('Digits in base 10, 0 through 9.') }}</li>
                <li class="small">{{ i18n('Non-alphabetic characters (e.g. !, $, #, %).') }}</li>
            </ol>
        </ul>
    </div>
</template>
<script>

export default {
    components: {},
    data() {
        return {};
    },
};
</script>